import { useQuery } from "@tanstack/react-query";
import { request } from "../../utilities/axios-utils.js";
import { objectToQueryParam } from "../../utilities/preQualificationUtils.js";

export const retrieveQuote = async (retrieveQuotePayload) => {
  try {
    if (retrieveQuotePayload?.accessToken) {
      const { accessToken, ...queryParamPayload } = retrieveQuotePayload;
      const retrieveUrlQuery = objectToQueryParam(queryParamPayload);
      const retrieveQuoteResponse = await request({
        url: `/callCentreSearchQuote?${retrieveUrlQuery}`,
        method: "GET",
        accessToken: retrieveQuotePayload.accessToken,
      });
      return retrieveQuoteResponse.data;
    }
  } catch (error) {
    console.error("Error while get questions :", error);
  }
};

export const useGetRetrieveQuote = (retrieveQuotePayload) =>
  useQuery({
    queryKey: ["getRetrieveQuote"],
    queryFn: async () => await retrieveQuote(retrieveQuotePayload),
    enabled: false,
    refetchOnWindowFocus: false,
  });
